function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import React, { Fragment } from "react";
import { Grid, Container, Card, CardContent, FormControl, TextField, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
// import { getDeviceDetailsBySid } from './utility';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardController from "./DashboardController";
export class TargetSettingsForm extends DashboardController {
  constructor(props) {
    super(props);
    //Customizable Area Start
    this.getTargetSettings();
    //Customizable Area End
  }
  render() {
    var _this$state$targetDat, _this$state$targetDat2, _this$state$targetDat3, _this$state$targetDat4, _this$state$targetDat5, _this$state$targetDat6;
    const {
      classes
    } = this.props;
    const handleChanger = event => {
      const targetData = _objectSpread({}, this.state.targetData);
      targetData[event.target.name] = event.target.value ? parseInt(event.target.value) : "";
      this.setState({
        targetData: targetData
      });
    };
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ToastContainer, null), /*#__PURE__*/React.createElement(Container, {
      style: {
        padding: 0
      },
      maxWidth: "xl"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        padding: "0 10px"
      }
    }, /*#__PURE__*/React.createElement("h1", null, "Target Settings")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Min Flow",
      type: "number",
      name: "min_flow",
      id: "targetFormMin_flow",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      error: (_this$state$targetDat = this.state.targetData) === null || _this$state$targetDat === void 0 ? void 0 : _this$state$targetDat.error_min_flow,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          color: 'red'
        }
      }, ((_this$state$targetDat2 = this.state.targetData) === null || _this$state$targetDat2 === void 0 ? void 0 : _this$state$targetDat2.error_min_flow) && "Please provide a valid value"),
      value: this.state.targetData.min_flow,
      onChange: handleChanger
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Max Flow",
      name: "max_flow",
      type: "number",
      id: "targetFormmax_flow",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.max_flow,
      onChange: handleChanger
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Min Speed",
      name: "min_speed",
      type: "number",
      id: "targetFormmin_speed",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.min_speed,
      onChange: handleChanger,
      error: (_this$state$targetDat3 = this.state.targetData) === null || _this$state$targetDat3 === void 0 ? void 0 : _this$state$targetDat3.error_min_speed,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          color: 'red'
        }
      }, ((_this$state$targetDat4 = this.state.targetData) === null || _this$state$targetDat4 === void 0 ? void 0 : _this$state$targetDat4.error_min_speed) && "Please provide a valid value")
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Max Speed",
      name: "max_speed",
      type: "number",
      id: "targetFormmax_speed",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.max_speed,
      onChange: handleChanger
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Min Load",
      name: "min_load",
      type: "number",
      id: "targetFormmin_load",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.min_load,
      onChange: handleChanger,
      error: (_this$state$targetDat5 = this.state.targetData) === null || _this$state$targetDat5 === void 0 ? void 0 : _this$state$targetDat5.error_min_load,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          color: 'red'
        }
      }, ((_this$state$targetDat6 = this.state.targetData) === null || _this$state$targetDat6 === void 0 ? void 0 : _this$state$targetDat6.error_min_load) && "Please provide a valid value")
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Max Load",
      name: "max_load",
      type: "number",
      id: "targetFormmax_load",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.max_load,
      onChange: handleChanger
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true,
      className: classes.formController
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "standard",
      label: "Production",
      type: "number",
      name: "production",
      id: "targetFormproduction",
      className: classes.fieldInput1,
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.labelProps
        }
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.cssOutlinedInput
        }
      },
      value: this.state.targetData.production,
      onChange: handleChanger
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        textAlign: "end"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      id: "savetargetData",
      className: classes.targetButton1,
      onClick: this.validateTargetData,
      variant: "contained"
    }, "Save")))))));
  }
}
const styles = () => ({
  card: {
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    borderRadius: 30,
    padding: "20px"
  },
  formController: {
    padding: "5px 10px",
    marginBottom: '20px'
  },
  labelProps: {
    fontSize: "20px",
    fontWeight: 600
  },
  textFieldRoot: {
    backgroundColor: "#00000000",
    padding: "5px"
  },
  cssOutlinedInput: {
    backgroundColor: "#e6e6e6",
    borderRadius: 7,
    marginTop: "25px!important",
    padding: "7px 20px"
  },
  targetButton1: {
    backgroundColor: "#7AA2FA!important",
    borderRadius: 7,
    color: "white",
    padding: "7px 65px"
  }
});
export default withStyles(styles)(TargetSettingsForm);